import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { signIn, signOut, getCurrentUser, fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';
import ServiceNavigation from './ServiceNavigation.jsx';
import TopPanel from './TopPanel';
import {
  AppLayout,
  Button,
  Box,
  ColumnLayout,
  Container,
  SpaceBetween,
} from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_vXh8uo1UN',
      userPoolClientId: 'h4bfm677vbqadnul5e49t4fsa',
      loginWith: {
        oauth: {
          domain: 'edgeservicesdemo.auth.us-east-1.amazoncognito.com',
          scopes: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin'
          ],
          redirectSignIn: ['https://demos.edge.aws.dev/', 'http://localhost:3000/'],
          redirectSignOut: ['https://demos.edge.aws.dev/', 'http://localhost:3000/'],
          responseType: 'code',
          providers: ['FederateOIDC']
        }
      }
    }
  }
});

function App() {

  const user = localStorage.getItem("user");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [checkingAuth, setCheckingAuth] = useState(true);

  const navigate = useNavigate();

  // Check if user is already authenticated on mount (after OAuth redirect)
  useEffect(() => {
    const checkUser = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          console.log("User already authenticated");
          // Store user info
          currentUser.expiryTTL = new Date().getTime() + (86400*1000);
          localStorage.setItem("user", JSON.stringify(currentUser));

          // During an OAuth callback (?code=...&state=...), we're on "/" momentarily while
          // Amplify exchanges the code. useAuth handles customOAuthState and stores the target
          // in localStorage.lastUrl; App.jsx will then redirect there once `user` is populated.
          // Only navigate here for the non-OAuth case (e.g. visiting /login while logged in).
          const params = new URLSearchParams(window.location.search);
          const isOAuthCallback = params.has('code') && params.has('state');
          if (!isOAuthCallback) {
            const target = localStorage.getItem("lastUrl") || "/";
            localStorage.removeItem("lastUrl");
            navigate(target);
          }
        }
      } catch (e) {
        console.log("No authenticated user found");
      } finally {
        setCheckingAuth(false);
      }
    };
    
    checkUser();
  }, [navigate]);

  // console.log("login invoked and user is " + user)

  function getUser() {
    // console.log("getUser called")
    // console.log(user)
    return user
  }

  async function signOutUser() {
    try {
      // Clear localStorage first
      localStorage.removeItem("user");
      localStorage.removeItem("userId");
      localStorage.removeItem("userProfile");
      localStorage.removeItem("lastUrl");
      
      // Sign out from Cognito
      await signOut({ global: true });
      
      console.log("User signed out successfully");
      
      // Force reload to clear any cached state
      window.location.href = "/login";
    } catch (error) {
      console.error("Error signing out:", error);
      // Even if sign-out fails, clear local data and redirect
      localStorage.clear();
      window.location.href = "/login";
    }
  }

  // Show loading while checking authentication
  if (checkingAuth) {
    return (
      <React.Fragment>
        <TopPanel label="Signin/SignOut" />
        <AppLayout
          navigationHide
          navigation={<ServiceNavigation />}
          toolsHide
          content={
            <Container>
              <Box textAlign="center" padding="xxl">
                Checking authentication...
              </Box>
            </Container>
          }
          contentType="default"
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <TopPanel label="Signin/SignOut" />
      <AppLayout
        // breadcrumbs={<Breadcrumbs />}
        // maxContentWidth
        navigationHide
        navigation={< ServiceNavigation />}
        toolsHide
        content={
          <Container header=<Box variant='h5'> Welcome to EdgeServices Demo Portal</Box> className="wip_class1">
          <ColumnLayout columns={2} variant='default'>

            {user ? (
              <Button variant="primary" onClick={() => signOutUser()}>Sign Out {user.username} </Button>
            ) : (
              <ColumnLayout columns={2} variant='text-grid'>

              <Button variant="primary" onClick={() => {
                setError("");
                try {
                  const target = localStorage.getItem("lastUrl") || "/";
                  signInWithRedirect({ 
                    provider: { custom: "FederateOIDC" },
                    customState: target
                  });
                } catch (e) {
                  console.error("Midway sign-in error:", e);
                  setError(`Midway sign-in failed: ${e.message}`);
                }
              }}>Signin With Midway</Button>
<SpaceBetween direction='vertical' size='m'>
    <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
    />
    <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
    />
    <Button variant="primary" onClick={async () => {
setError("");
try {
  await signIn({ username, password });
  console.log("signed in custom");
  
  // Get the current user and store in localStorage
  const currentUser = await getCurrentUser();
  currentUser.expiryTTL = new Date().getTime() + (86400*1000);
  localStorage.setItem("user", JSON.stringify(currentUser));
  
  const target = localStorage.getItem("lastUrl") || "/";
  localStorage.removeItem("lastUrl");
  navigate(target);
} catch(e) {
  console.log("Error:", e);
  setError(e.message);
}
}}>Signin With Custom</Button>
    <Box color="text-status-error">{error}</Box>
</SpaceBetween>
</ColumnLayout>

            )}
          </ColumnLayout>
          </Container>
        }
        contentType="default"

      />
    </React.Fragment>
  );
}

export default App;
